// extracted by mini-css-extract-plugin
module.exports = {"favoritePanel":"FavoritePanel_favoritePanel__2WqWC"};